<template>
  <div class="st-content">
    <div class="honor-box">
      <div
        class="st-listitem"
        v-for="item in honorList"
        :key="item.id"
        @click="prewImg(item)"
      >
        <div class="left">
          <img :src="URL + item.imgUrl" />
        </div>
        <div class="right">
          <p class="title">{{ item.title }}</p>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
    <div class="up" v-show="nowImage" @click="close">
      <i class="close el-icon-circle-close"></i>
      <img class="show" :src="nowImage" alt="" />
    </div>
  </div>
</template>

<script>
import { URL } from "../util/config.js";
import { syshonorList as getHonorList } from "../util/honor/honor.js";
export default {
  data() {
    return {
      URL,
      honorList: [],
      nowImage: "",
    };
  },
  created() {
    const formData = { honorType: 0 };
    //获取列表
    getHonorList(formData).then((res) => {
      if (res.code === 0) {
        this.honorList = res.data;
      }
    });
  },
  mounted() {},
  methods: {
    prewImg(item) {
      this.nowImage = this.URL + item.imgUrl;
    },
    close(e) {
      let nodeName = e.target.nodeName;
      if (nodeName != "IMG") {
        this.nowImage = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.st-content {
  .honor-box {
    display: flex;
    flex-wrap: wrap;

    .left {
      img {
        width: 290px;
      }
    }
    .right {
      text-align: center;
    }

    .st-listitem {
      width: auto;
      margin-top: 0;
      margin-bottom: 20px;
      margin-right: 40px;

      &:hover {
        cursor: zoom-in;
      }

      &:nth-child(3n) {
        margin-right: 0;
      }

      .left {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
      }
    }
  }
}
.up {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba($color: #000000, $alpha: 0.6);

  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 10;
    cursor: pointer;
    font-size: 40px;
    color: #fff;
  }
  .show {
    max-height: 800px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
@media (max-width: 1500px) {
  .st-content {
    .honor-box {
      .left {
        img {
          width: 250px;
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .st-content {
    .honor-box {
      .left {
        img {
          width: 2rem;
        }
      }
    }
  }
}
</style>
